module.exports = __webpack_public_path__ + "img/truck.b9a9b606.svg";